import React from 'react';
import {
    makeStyles,
    Container,
    Grid,
    Typography,
    Button,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import Details from '../MyLeave/component/Details';
import CompLeaveReqsCollection from '../Function/CompLeaveReqs';
import CircularProgress from '@material-ui/core/CircularProgress';
import customAxios from '../API/customAxios';
import { FormattedMessage, useIntl } from 'react-intl';
import { tableStyle, getMuiTheme } from '../UIComponent/CommonStyle';
import BalanceTable from './component/BalancePage';
import Edit from './component/Edit';
import { isDesktop } from "react-device-detect";
import {
    getCompLeaveReqRecordOptions,
    getBalanceRecordOptions,
    getColumnsForCompLeaveReqRecord,
} from './component/TableSetting';

const useStyles = makeStyles((theme) => ({
    ...tableStyle(theme),
    spaceBetween: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}));

export default function MyCompLeaveRequestPage({ routing, routingId }) {
    const classes = useStyles();
    const intl = useIntl();
    const page = 'Comp Leave Reqs';
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [showId, setShowId] = React.useState();
    const [editId, setEditId] = React.useState();
    const [openBalance, setOpenBalance] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [openEdit, setOpenEdit] = React.useState(false);

    React.useEffect(() => {
        if (routing !== '') {
            setEditId(routingId);
            setOpenEdit(routing);
        }
    }, [routing]);

    React.useEffect(() => {
        customAxios.get('/get_my_comp_leave_reqs').then((res) => {
            const getCompLeaveReqs = res.data;
            setData(
                CompLeaveReqsCollection(getCompLeaveReqs, intl, 'CompLeaveReqs')
            );
            setShowCompetent(true);
        });
    }, []);

    const handleCloseBalance = () => {
        setOpenBalance(false);
    };
    const handleOpenBalance = () => {
        setOpenBalance(true);
    };

    const handleOpen = (id) => {
        setShowId(id);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpenEdit = (id) => {
        setEditId(id);
        setOpenEdit(true);
    };
    const handleCloseEdit = () => {
        setOpenEdit(false);
    };

    const columns = getColumnsForCompLeaveReqRecord(
        handleOpen,
        handleOpenEdit,
        intl
    );
    const options = getCompLeaveReqRecordOptions(intl);

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth={false} className={classes.container}>
                {showCompetent ? (
                    <>
                        <Grid container spacing={3}>
                            <Grid item xs={12} className={isDesktop ? classes.spaceBetween : ''}>
                                <Typography
                                    align='left'
                                    style={{
                                        fontSize: '1.6em',
                                        fontWeight: 600,
                                    }}
                                >
                                    {intl.formatMessage({id: 'navigation.my_requests'}) + ' - ' + intl.formatMessage({id: 'navigation.ot_compensation'})}
                                </Typography>
                                <div>
                                    <Button
                                        onClick={handleOpenBalance}
                                        variant='contained'
                                        size='medium'
                                        style={{
                                            backgroundColor: 'green',
                                            color: '#FFF',
                                            width: '100%',
                                            marginTop: isDesktop ? 0 : 12,
                                        }}
                                    >
                                        {intl.formatMessage({
                                            id: 'comp_leave.endorsed_balance',
                                        })}
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <MuiThemeProvider theme={getMuiTheme()}>
                                    <MUIDataTable
                                        title={intl.formatMessage({
                                            id: 'comp_leave.request_record',
                                        })}
                                        data={data}
                                        columns={columns}
                                        options={options}
                                    />
                                </MuiThemeProvider>
                            </Grid>
                        </Grid>
                    </>
                ) : (
                    <>
                        <div className={classes.circularProgress}>
                            <CircularProgress />
                        </div>
                    </>
                )}
            </Container>
            {open && (
                <Details
                    handleClose={handleClose}
                    open={open}
                    showId={showId}
                    page={page}
                ></Details>
            )}
            {openEdit && (
                <Edit
                    handleClose={handleCloseEdit}
                    open={openEdit}
                    showId={editId}
                    actionPage='Comp Leave Reqs'
                ></Edit>
            )}
            {openBalance && (
                <BalanceTable
                    handleClose={handleCloseBalance}
                    open={openBalance}
                />
            )}
        </main>
    );
}
